import { useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import SwitchInput from "../SwitchInput/SwitchInput";

const SwitchInputConainer = (props) => {
  const [checked, setChecked] = useState(
    props.data.options && props.data.options[1].id,
  );
  const { formData, setFormData } = useFormStore();

  useEffect(() => {
    formData[props.data.id]
      ? setChecked(formData[props.data.id])
      : setFormData(
          props.data.id,
          props.data.options && props.data.options[1].id,
        );
  }, []);

  function selectChangeHandler(value) {
    setChecked(value);
    setFormData(props.data.id, value);
  }
  return (
    <SwitchInput
      options={props.data.options || []}
      name={props.data.name}
      id={props.data.id}
      checked={checked}
      selectChangeHandler={selectChangeHandler}
    />
  );
};

export default SwitchInputConainer;
